import React from "react";

import IViewContext from "@app/component/view/types/IViewContext";
import FieldModel from "@app/util/fieldModel/impl/FieldModel";

// Create view context with some default values
const ViewContext = React.createContext<IViewContext>({
  entityType: undefined,
  fieldModel: new FieldModel([]),
  register: () => {},
  totalRecords: 0,
  unregister: () => {},
  updateColumnVisibility: () => {},
  updateEntity: () => {},
  updateFilterModel: () => {},
  updateViewState: () => {},
  updateViewStateAndFetch: () => {},
  viewState: {
    columns: [],
    filter: { conditions: [], operator: "AND" },
    range: { endRow: 0, startRow: 0 },
    sort: [],
  },
});

export default ViewContext;
